{
  "listConfig": {
    "dataSource1": [
      "Sold Proposals/Addenda"
    ],
    "dataSource2": [
      "Account Policy Download"
    ]
  }
}